import type { FormProps } from "antd";
import { Button, Form, Input, message } from "antd";
import { authService } from "../services/auth.service";
import { useNavigate } from "react-router-dom";

type FieldType = {
  username: string;
  password: string;
};

export default function LoginForm() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    try {
      const { access_token } = await authService.login(values);
      authService.setToken(access_token);
      messageApi.success("Login successful!");
      navigate("/");
    } catch (e) {
      messageApi.error("Login failed. Please check your credentials.");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Form
          name="basic"
          style={{ maxWidth: 300, width: "100%" }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item<FieldType>
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>

          <Form.Item<FieldType>
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </div>
      {contextHolder}
    </>
  );
}
